export default __webpack_public_path__ + "static/media/ver_proximas_citas.b9769eb6.jpeg";